<template>
    <!-- 关于我们 1  -->
    <sub-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg"
        :rightBg="rightBg" />
</template>

<script>
import SubPage from '@/views/components/SubPage.vue'
export default {
    name: 'aboutOne',
    components: {
        SubPage
    },
    data() {
        return {
            bg: "/img/pay/0--36.png",
            rightBg: "/img/pay/0--66.png",
        }
    },
    computed: {
        title() {
            return this.$t('aboutOne.title');
        },
        subtitle() {
            return this.$t('aboutOne.subtitle');
        },
        description() {
            // 确保返回数组格式的描述
            const desc = this.$t('aboutOne.description');
            return Array.isArray(desc) ? desc : [desc];
        },
        buttonText() {
            return this.$t('common.buttonText');
        }
    }

}
</script>